import { variants } from '~/chords/lib/variants';

export const breadcrumbsRootVariants = variants({
  base: 'flex items-center justify-start space-x-sm self-stretch',
  variants: {
    size: {
      default: 'min-h-[1.5rem] text-body-sm text-subtle',
      heading: 'text-headline-md font-semibold text-subtle',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const breadcrumbsLinkVariants = variants({
  base: 'duration-300',
  variants: {
    emphasis: {
      default: 'underline text-default hover:text-hover',
      subtle: 'no-underline text-subtle hover:text-default',
    },
  },
  defaultVariants: {
    emphasis: 'default',
  },
});
